import { przezmorzeApi } from "../../../api/api";
import type {
  AccountManagerThreshold,
  CustomersAutomationConfig,
  OrdersAutomationConfig,
  UpdateCustomersAutomationConfigRequest,
  UpdateOrdersAutomationConfigRequest,
} from "@przezmorze/api-types";

export type { AccountManagerThreshold, CustomersAutomationConfig, OrdersAutomationConfig };

export async function getOrdersConfig(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<OrdersAutomationConfig>("/automation-config/orders", {
    signal: abortSignal,
  });
  return response.data;
}

export async function updateOrdersConfig(
  body: UpdateOrdersAutomationConfigRequest,
  abortSignal?: AbortSignal,
): Promise<OrdersAutomationConfig> {
  const response = await przezmorzeApi.put<OrdersAutomationConfig>("/automation-config/orders", body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function getCustomersConfig(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<CustomersAutomationConfig>("/automation-config/customers", {
    signal: abortSignal,
  });
  return response.data;
}

export async function updateCustomersConfig(
  body: UpdateCustomersAutomationConfigRequest,
  abortSignal?: AbortSignal,
): Promise<CustomersAutomationConfig> {
  const response = await przezmorzeApi.put<CustomersAutomationConfig>("/automation-config/customers", body, {
    signal: abortSignal,
  });
  return response.data;
}
